module.exports = __webpack_public_path__ + "static/media/nl.a0f887ac.svg";